import React, {
  useMemo,
} from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";
import { viewerPanelSurfaceSx } from "./unityWebViewer/panelStyles";

const Label = ({
  labelPosition,
  displayName,
  subtitle,
  alignment = "auto", // "auto" flips left/right based on x
  offsetLeft = 0,
  portal = false,
  portalZIndex = 30,
}) => {
  // Decide left vs right if in "auto" mode
  const effectiveAlignment = useMemo(() => {
    if (alignment === "auto") {
      const w = typeof window !== "undefined" ? window.innerWidth : 0;
      return labelPosition.x < w / 3 ? "right" : "left";
    }
    return alignment;
  }, [alignment, labelPosition.x]);

  // Map alignment to CSS translate
  const transform = useMemo(() => {
    switch (effectiveAlignment) {
      case "left":
        return "translate(-105%, -50%)";
      case "right":
        return "translate(5%, -50%)";
      case "top":
        return "translate(-50%, -105%)";
      case "bottom":
        return "translate(-50%, 5%)";
      default:
        return "translate(-50%, -50%)";
    }
  }, [effectiveAlignment]);

  const label = (
    <Box
      sx={{
        position: portal ? "fixed" : "absolute",
        top: labelPosition.y,
        left: labelPosition.x + offsetLeft,
        transform,
        zIndex: portal ? portalZIndex : undefined,
        ...viewerPanelSurfaceSx,
        color: "var(--label-text, #f2fffc)",
        px: 2,
        py: 1,
        boxSizing: "border-box",
        pointerEvents: "none",
        overflow: "hidden",
        display: "inline-block",
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      <Typography variant="h5">{displayName}</Typography>
      {subtitle && (
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "var(--label-subtitle, rgba(8, 48, 51, 0.8))", letterSpacing: "0.05em" }}
        >
          <em>{subtitle}</em>
        </Typography>
      )}
    </Box>
  );

  if (portal && typeof document !== "undefined") {
    return createPortal(label, document.body);
  }

  return label;
};

export default Label;
